// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"59ca95fc","455":"91b76c76","977":"074d52ee"}[chunkId] + ".chunk.js";
};